/**
 * Shared volume calculation: sum of (weight × reps) for all sets across all exercises.
 *
 * Optionally converts units so every caller gets a consistent number.
 */

/** Convert a weight value between unit systems */
export function convertWeight(value: number, from: string, to: string): number {
  if (from === to) return value;
  if (from === 'lbs' && to === 'kg') return value / 2.20462;
  if (from === 'kg' && to === 'lbs') return value * 2.20462;
  return value;
}

/**
 * Calculate total volume for a single workout payload.
 *
 * @param payload  - workout payload (object or JSON string)
 * @param targetUnits - if provided, converts each set's weight to this unit system before multiplying
 * @returns total volume (weight × reps summed across all sets)
 */
export function calculateWorkoutVolume(
  payload: any,
  targetUnits?: string,
): number {
  if (typeof payload === 'string') {
    try {
      payload = JSON.parse(payload);
    } catch {
      return 0;
    }
  }
  const workoutUnits: string = payload?.units ?? 'lbs';
  let vol = 0;
  for (const ex of payload?.exercises ?? []) {
    for (const s of ex.sets ?? []) {
      let weight = Number(s.weight) || 0;
      if (targetUnits) {
        weight = convertWeight(weight, workoutUnits, targetUnits);
      }
      vol += weight * (Number(s.reps) || 0);
    }
  }
  return Math.round(vol * 100) / 100;
}
